import React from 'react';
import styled from 'styled-components';
import { version } from '../../../../package.json';

export const Version = () => <Wrapper className="version">v{version}</Wrapper>;

export default Version;

const Wrapper = styled.div`
  font-size: 0.8em;
  width: 100%;
  color: white;
  text-align: center;
  margin-top: -30px;
  margin-bottom: 15px;
`;
